import { useRouter } from "next/compat/router";
import { analytics } from "@lib/trackers/analytics";
import Link from "@components/core/Link";

const ListingPageLink = ({
  title,
  carousel_title: carouselTitle,
  slug,
  hub_image_url: hubImageUrl,
  listing_pages: listingPages,
  hubSlug,
  prevSlug = "",
  sliderPosition,
}) => {
  const router = useRouter();
  const linkHref = `${prevSlug}/${slug}`;

  const displayListingPages = () => {
    const hasChildren = listingPages && listingPages.length;

    if (!hasChildren) return null;

    return listingPages.map((listingPage) => (
      <ListingPageLink
        key={`listing-page-${listingPage.id}`}
        hubSlug={hubSlug}
        prevSlug={linkHref}
        {...listingPage}
      />
    ));
  };

  function displayHubImage() {
    return (
      <div
        data-testid={`hub-image-${slug}`}
        className="listing-page-link-picture-container"
      >
        <img
          className="listing-page-link-picture"
          src={hubImageUrl}
          alt={title}
        />
      </div>
    );
  }

  function sendTrackerData() {
    analytics.track("$click", {
      tracking_name: "hubCollectionListSlider",
      page: router.asPath,
      hub_slug: hubSlug,
      listing_page_slug: slug,
      listing_page_title: carouselTitle || title,
      position: sliderPosition,
    });
  }

  if (!hubImageUrl) return null;

  return (
    <div>
      <Link
        variant="link-dark"
        noUnderline
        href={`/${hubSlug}${linkHref}`}
        passHref
        className="listing-page-link-title-container"
        data-testid={`listing-page-link-${slug}`}
        onClick={() => sendTrackerData()}
      >
        {displayHubImage()}
        <h6 className="listing-page-link-title">{carouselTitle || title}</h6>
      </Link>
      {displayListingPages()}
    </div>
  );
};

export default ListingPageLink;
